import Vue from 'vue';
import ProjectStatusSwitcher from './components/ProjectStatusSwitcher';
import TaskAdder from './components/TaskAdder';
import TaskList from './components/TaskList';
import PostList from './components/PostList';
import store from './store';

export function projectView(project, options) {
  options = Object.assign({
    edit: false,
    viewTasks: false,
    addTasks: false,
    viewWork: false,
  }, options);

  store.commit('setCurrentProject', project);

  if (options.edit) {
    new Vue({
      el: '.project-status-switcher',
      render: h => h(ProjectStatusSwitcher),
      store,
    });
  }

  if (options.addTasks) {
    new Vue({
      el: '#task-adder',
      render: h => h(TaskAdder, {props: {
        selectedProject: project.id,
      }}),
      store,
    });
  }

  if (options.viewTasks) {
    new Vue({
      el: '#task-list',
      render: h => h(TaskList),
      store,
    });
  }

  if (options.viewPosts) {
    new Vue({
      el: '#post-list',
      render: h => h(PostList),
      store,
    });
  }
}

export function projectPermissions() {
  var rows = $('.permission-rows');

  $('.add-row').click(function(e) {
    e.preventDefault();
    var selected = $('#available-users option:selected');

    var index = rows.find('tr').length;
    var fullname = selected.data('fullname');
    var userId = selected.data('user-id');
    var accountId = selected.data('account-id');
    var icon = selected.data('icon');

    var row = $('#prototype').html()
        .replace(/__INDEX__/g, index)
        .replace(/__FULLNAME__/g, fullname)
        .replace(/__USER_ID__/g, userId)
        .replace(/__ACCOUNT_ID__/g, accountId)
        .replace(/__ICON__/g, icon)
    ;

    rows.append(row);
  });

  $(document).on('click', '.permission-rows .remove', function(e) {
    e.preventDefault();
    $(this).parents('tr').remove();
  });
};



// WEBPACK FOOTER //
// ./assets/js/projects.js